<template>
  <div
    class="pa-0 ml-auto mr-auto justify-center flex-column profile-account-management"
  >
    <div class="form-title mb-3">
      {{ $t("Account management") }}
    </div>
    <div
      v-text="
        $t(
          'You can delete your user account on this page. This action is irrevocable.'
        )
      "
    />
    <div class="profile-account-management__wrapper">
      <Button
        color="error"
        @click="deletionConfirmationDialog = true"
      >
        <v-icon>mdi-delete</v-icon>
        {{ $t("Delete Account") }}
      </Button>
    </div>
    <ConfirmationDialog
      v-model="deletionConfirmationDialog"
      :message="$t('Are you sure you want to delete* your account? This action is irrevocable.')"
      confirm-text="Delete"
      cancel-text="Cancel"
      :has-deletion-check="true"
      @confirm="
        deletionConfirmationDialog = false;
        handleDeletion();
      "
      @cancel="deletionConfirmationDialog = false"
    />
    <Button
      class="col-6 single-profile-button"
      color="secondary"
      :scroll="true"
      @click="$emit('goto', 'data-sharing')"
    >
      <v-icon start>
        mdi-chevron-left
      </v-icon>
      {{ $t("Previous") }}
    </Button>
  </div>
</template>

<script setup lang="ts">
import { ref, getCurrentInstance } from "vue"
import ConfirmationDialog from "@/components/dialogs/ConfirmationDialog.vue"
import Button from "@/components/input-components/Button.vue"
import { ProfileService } from "@/services/profile.service"
import NotificationMessageService from "@/services/notificationmessage.service"
import { useI18n } from 'vue-i18n'

const {t} = useI18n()

defineOptions({ name: "ProfileAccountManagement" });

const emit = defineEmits<{goto: []}>()

const deletionConfirmationDialog = ref(false)
const profileService = new ProfileService()

const { proxy } = getCurrentInstance() ?? {}

function handleDeletion() {
  const keycloak = proxy?.$keycloak
  const t = proxy?.$t as (msg: string) => string

  if (keycloak?.subject) {
    profileService
      .deleteUser(keycloak.subject)
      .then(() => {
        NotificationMessageService.showSuccess(
          t("Deletion successfully. You will be logged out.")
        )
        keycloak.logout()
      })
      .catch(() => {
        NotificationMessageService.showError(
          t("Something went wrong. Please try again later.")
        )
      })
  } else {
    NotificationMessageService.showError(
      t("Something went wrong. Please try again later.")
    )
  }
}
</script>

<style lang="scss">
.profile-account-management {
  &__wrapper {
    margin-top: 1rem;
    margin-bottom: 1.5rem;
  }

  .single-profile-button {
    max-width: 194px;
  }
}
</style>
